import './BrokerageMap.scss';
export {default} from './BrokerageMap';
